import { useEffect } from "react";
import Navbar from "../Navbar";
import DisplayGame from "../Play/GameUI/GameIndex";

/**
 * Renders the "/iron-sights" page
 * @returns html containing a page that allows you to play iron sights
 */
const IronSights = () => {
  useEffect(() => {
    document.title = "Iron Sights - FPS Aim Trainer";
  }, []);

  return (
    <div className="h-screen flex flex-col">
      <Navbar />
      <div className="w-screen flex-1">
        <DisplayGame ironsights={true} duels={false} />
      </div>
    </div>
  );
};

export default IronSights;
